<template>
  <a
    v-if="link"
    class="bottom-ad"
    :class="{ 'bottom-ad--fixed': fixedBottom }"
    :href="link"
  >
    <img
      class="bottom-ad__image"
      referrerpolicy="no-referrer"
      :src="image"
      alt="广告图片"
    />
    <span v-if="showTag" class="bottom-ad__tag">广告</span>
  </a>
  <div
    v-else
    class="bottom-ad"
    :class="{ 'bottom-ad--fixed': fixedBottom }"
  >
    <img
      class="bottom-ad__image"
      referrerpolicy="no-referrer"
      :src="image"
      alt="广告图片"
    />
    <span v-if="showTag" class="bottom-ad__tag">广告</span>
  </div>
</template>

<script>
export default {
  name: 'BottomAd',
  props: {
    image: { type: String, required: true },      // 图片 URL
    link: { type: String, default: '' },          // 跳转地址
    showTag: { type: Boolean, default: true },    // 是否显示广告角标
    fixedBottom: { type: Boolean, default: true } // 是否固定在页面底部
  }
};
</script>

<style scoped>
.bottom-ad {
  display: block;
  width: var(--content-width);
  height: 136px;
  position: relative;
}

.bottom-ad--fixed {
  position: absolute;
  left: var(--space-6);
  bottom: 32px;
}

.bottom-ad__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bottom-ad__tag {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0 0 0 8px;
  color: var(--color-white);
  font-size: var(--font-xs);
  font-family: var(--font-primary);
  text-align: center;
  white-space: nowrap;
  line-height: 14px;
}
</style>
